<p-card data-testid="normalization-range-card" *transloco="let t; prefix: 'project'">
  <h3
    class="text-lg font-semibold mb-4 flex items-center gap-3"
    data-testid="normalization-range-header"
  >
    {{ t('steps.normalizationValues') }}
    <app-directus-tooltip
      tooltipStyleClass="tooltip-bg-second-level"
      tooltipKey="projectSetting_normalizationValues"
    ></app-directus-tooltip>
  </h3>

  <form [formGroup]="normalizationForm" class="flex flex-col gap-6">
    <div class="flex gap-6 max-w-2xl">
      <app-form-field
        id="minPriceOffer"
        [fieldName]="'minPriceOffer'"
        [label]="'project.steps.minPriceOffer'"
        [showButtons]="false"
        type="number"
        [mode]="'decimal'"
        data-testid="min-price-offer"
      ></app-form-field>

      <div class="flex items-end gap-2">
        <div class="flex flex-col gap-2 mb-3">
          <span> {{ t('steps.minPriceOfferX') }}</span>
        </div>
        <app-form-field
          id="maxPriceToGetPoints"
          [fieldName]="'maxPriceToGetPoints'"
          [label]="'project.steps.maxPriceToGetPoints'"
          [showError]="false"
          type="number"
          [mode]="'decimal'"
          [maxFractionDigits]="1"
          [step]="0.1"
          data-testid="max-price-to-get-points"
        ></app-form-field>
      </div>
    </div>

    @if (normalizationForm.valid && hasChanges()) {
      <div class="flex justify-end gap-2 mt-4">
        <app-project-step-save-button
          [loading]="isSaving()"
          [disabled]="isSaving()"
          (clicked)="onSubmit()"
        ></app-project-step-save-button>
      </div>
    }
  </form>
</p-card>
